export enum CareFusionEthnicGroup {
    afroCaribbean = 'afroCaribbean',
    asian = 'asian',
    caucasian = 'caucasian',
    latinAmerican = 'latinAmerican',
    nonCaucasian = 'nonCaucasian',
    notSpecified = 'notSpecified',
    other = 'other',
    polynesian = 'polynesian',
}
